import { create } from "zustand";
import api from "../../services/api";

const usePaymentMethodStore = create((set) => ({
  paymentMethods: [],
  loading: false,
  error: null,

  getAllPaymentMethods: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/payment-methods");
      set({ paymentMethods: response.data, loading: false });
    } catch (error) {
      console.log("erro ao obter metodos de pagamento: ", error);
      set({ error: error.message, loading: false });
    }
  },

  addPaymentMethod: (paymentMethod) => {
    set((state) => ({
      paymentMethods: [...state.paymentMethods, paymentMethod],
    }));
  },

  updatePaymentMethod: (id, data) => {
    set((state) => ({
      paymentMethods: state.paymentMethods.map((paymentMethod) => {
        if (paymentMethod.id === id) {
          return {
            ...paymentMethod,
            ...data,
            id,
          };
        }

        return paymentMethod;
      }),
    }));
  },

  removePaymentMethod: (id) => {
    set((state) => {
      console.log("ID recebido para exclusão:", id);
      console.log(
        "Métodos de pagamento antes da exclusão:",
        state.paymentMethods
      );

      const updatedPaymentMethods = state.paymentMethods.filter(
        (paymentMethod) => Number(paymentMethod.id) !== Number(id)
      );

      console.log(
        "Métodos de pagamento após a exclusão:",
        updatedPaymentMethods
      );

      return { paymentMethods: updatedPaymentMethods };
    });
  },
}));

export default usePaymentMethodStore;
